import React, { useState, useEffect } from "react";
import NavLink from "./NavLink";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";
import MenuOverlay from "./MenuOverlay";
import { useLocation } from "react-router-dom";
import { useCallback } from "react";

const navLinks = [
  {
    title: "HOME",
    path: "/",
  },

  {
    title: "ABOUT",
    path: "/about",
  },
 
  {
    title: "PRODUCTS",
    path: "/product",
  },
  {
    title: "BLOG",
    path: "/blog",
  },
  {
    title: "CONTACT",
    path: "/contact",
  },
];

const NavBar = () => {
  const [navbarOpen, setNavbarOpen] = useState(false);
  const location = useLocation();
  const [color, setColor] = useState(false);
  // Removed unused isMobile state

  const isHomepage = location.pathname === "/";
  const toggleNavbar = () => {
    setNavbarOpen(!navbarOpen);
  };

  const changeColor = () => {
    if (window.scrollY <= 50) {
      setColor(true);
    } else {
      setColor(false);
    }
  };

  const handleResize = useCallback(() => {
    // Removed setIsMobile as isMobile is not used
    if (window.innerWidth > 768 && navbarOpen) {
      setNavbarOpen(false);
    }
  }, [navbarOpen]);

  useEffect(() => {
    changeColor();
    window.addEventListener("scroll", changeColor);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("scroll", changeColor);
      window.removeEventListener("resize", handleResize);
    };
  }, [navbarOpen, handleResize]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-10 sm:pt-[19px] md:pt-0 bg-opacity-100 ${
       navbarOpen ? 'bg-secondary1' :  isHomepage && color ? "" : "bg-secondary1"
      }`}
    >
      <div className="flex flex-row items-center justify-between px-4 md:pl-[10rem] py-2 md:pr-[7rem] max-sm:pr-[10px]">
        <a href="/" className="text-lg md:text-5xl text-secondary1 font-thin">
          <img
            className="md:w-[208px] w-[108px] p-0"
            src={
              isHomepage && color ? "./images/logo2.png" : "./images/logo1.png"
            }
            alt="logo"
          />
        </a>
        <div className="mobile-menu block md:hidden">
          {!navbarOpen ? (
            <button
              onClick={() => setNavbarOpen(true)}
              className={`flex items-center px-3 py-2 border rounded ${
                isHomepage && color
                  ? "border-gold text-gold"
                  : "border-tertary2 text-tertary2"
              }`}
            >
              <FontAwesomeIcon icon={faBars} className="h-5 w-5" />
            </button>
          ) : (
            <button
              onClick={() => setNavbarOpen(false)}
              className={`flex items-center px-3 py-2 border rounded ${
                isHomepage && color
                  ? "border-gold text-gold"
                  : "border-tertary2 text-tertary2"
              }`}
            >
              <FontAwesomeIcon icon={faTimes} className="h-5 w-5" />
            </button>
          )}
        </div>
        <div className="menu hidden md:block md:w-auto" id="navbar">
          <ul className="flex p-4 md:p-0 md:flex-row md:space-x-8 mt-0 ">
            {navLinks.map((link, index) => (
              <li
                className="w-fit tracking-[0] whitespace-nowrap relative"
                key={index}
              >
                {" "}
                <NavLink href={link.path} title={link.title} />
              </li>
            ))}
          </ul>
        </div>
      </div>
      {navbarOpen ? (
        <MenuOverlay links={navLinks} onToggleNavbar={toggleNavbar} />
      ) : (
        ""
      )}
    </nav>
  );
};

export default NavBar;